import styled from 'styled-components';

const ContentText = styled.p`
  color: #003876;
  text-align: justify;
  line-height: 21px;
`;
const ContentTitle = styled.p`
  color: #003876;
  width: 100%;
  font-weight: 600;
  font-size: larger;
  line-height: 21px;
  align-items: flex-start;
  margin: 0;
  margin-top: 20px;
`;

const InfoContainer = styled.div`
  display: 'flex';
  flex-direction: column;
  max-width: 100%;
  overflow-y: scroll;
  padding-right: 30px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export { ContentText, ContentTitle, InfoContainer };
